import { NgModule } from '@angular/core';

import { AttachmentComponent }        from './attachment.component';
import { AttachmentsBoxComponent }    from './attachments.box.component';
import { AttachmentsSelectComponent } from './attachments.select.component';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    AttachmentComponent,
    AttachmentsBoxComponent,
    AttachmentsSelectComponent
  ],
  entryComponents: [
    AttachmentComponent,
    AttachmentsBoxComponent,
    AttachmentsSelectComponent
  ],
  exports: [
    AttachmentComponent,
    AttachmentsBoxComponent,
    AttachmentsSelectComponent
  ],
  imports: [
    SharedModule
  ]
})
export class AttachmentsModule {}
